import { Box, Chip, Stack, Typography } from '@mui/material';
import { MdCheckCircle, MdInfoOutline } from 'react-icons/md';
import Input from 'components/Common/Input';
import { sampleHasBrand, sampleHasOptOut, shrinkLabel, StepFormProps } from './campaignFormShared';

type Props = StepFormProps & { brandName: string };

const SAMPLES: Array<{
  name: 'sample1' | 'sample2' | 'sample3' | 'sample4' | 'sample5';
  label: string;
  required: boolean;
}> = [
  { name: 'sample1', label: 'Sample 1', required: true },
  { name: 'sample2', label: 'Sample 2', required: true },
  { name: 'sample3', label: 'Sample 3', required: false },
  { name: 'sample4', label: 'Sample 4', required: false },
  { name: 'sample5', label: 'Sample 5', required: false }
];

function PresenceChips({ text, brandName }: { text: string; brandName: string }) {
  if (!text.trim()) return null;
  const brandOk = sampleHasBrand(text, brandName);
  const optOutOk = sampleHasOptOut(text);
  const chipSx = {
    height: 24,
    borderRadius: '999px',
    fontSize: 12,
    fontWeight: 500,
    bgcolor: '#DCFCE7',
    color: '#15803D',
    '& .MuiChip-icon': { color: '#15803D' }
  };

  return (
    <Stack direction='row' spacing={1} mt={1} flexWrap='wrap' useFlexGap>
      {brandOk && <Chip icon={<MdCheckCircle size={14} />} label='Brand name present' sx={chipSx} />}
      {optOutOk && <Chip icon={<MdCheckCircle size={14} />} label='Opt-out language present' sx={chipSx} />}
    </Stack>
  );
}

export default function SampleMessagesStep({ control, watch, brandName }: Props) {
  const samples = {
    sample1: watch('sample1') || '',
    sample2: watch('sample2') || '',
    sample3: watch('sample3') || '',
    sample4: watch('sample4') || '',
    sample5: watch('sample5') || ''
  };

  return (
    <Box>
      <Box bgcolor='#EFF6FF' borderRadius='8px' px={2} py={1.5} mb={2.5}>
        <Stack direction='row' spacing={1} alignItems='flex-start'>
          <Box color='#2563EB' mt={0.15}>
            <MdInfoOutline size={18} />
          </Box>
          <Box>
            <Typography fontSize={13} fontWeight={600} color='#2563EB' mb={0.25}>
              TIP:
            </Typography>
            <Typography fontSize={13} color='#2563EB' lineHeight={1.6}>
              Include your brand name at the start of each message and always include &quot;Reply STOP to
              unsubscribe&quot; to satisfy carrier requirements.
            </Typography>
          </Box>
        </Stack>
      </Box>

      {SAMPLES.map((sample) => (
        <Box key={sample.name} mb={2}>
          <Input
            name={sample.name}
            control={control}
            label={sample.label}
            placeholder='Enter Text Here'
            required={sample.required}
            fullWidth
            multiline
            minRows={3}
            InputLabelProps={shrinkLabel}
            rules={
              sample.required
                ? { required: `${sample.label} is required`, minLength: { value: 20, message: 'Min 20 characters' } }
                : undefined
            }
          />
          <PresenceChips text={samples[sample.name]} brandName={brandName} />
        </Box>
      ))}
    </Box>
  );
}
